<template>
    <div class="container" style="width:99%;margin-top:-25px;">
      <!--工具栏-->
      <div class="toolbar" style="float:left;padding:10px 12px;width:100%;box-sizing:border-box;background:linear-gradient(180deg,#fff 0%,#f8f9fb 100%);border-bottom:1px solid #e4e7ed;">
		<div class="filter-bar">
        <el-form :inline="true" :model="filters" :size="size" style="display:flex;align-items:center;flex-wrap:wrap;gap:6px;">
          <el-form-item style="margin-bottom:0;" class="filter-item">
            <SearchWhseClient ref="searchWhseClient" :whId="filters.whId" :clientCode="filters.clientCode" @search-whse-event="getSearchWhseClient(arguments)" perms="sys:rfMainProcessDetail:view" type="primary"/>
          </el-form-item>
          <el-form-item style="margin-bottom:0;" class="filter-item">
            <el-select ref="subProcessName" v-model="filters.subProcessName" :placeholder="$t('RfSubProcessOption.subProcessName')" size="small" style="width: 150px;">
              <el-option :label="$t('RfSubProcessOption.option.any')" value="%"></el-option>
              <el-option v-for="(name, index) in subProcessNames" :key="index" :value="name" :label="name"/>
            </el-select>
          </el-form-item>
        </el-form>
        </div>
        <div class="action-bar">
          <kt-button :label="$t('action.search')" perms="sys:rfMainProcessDetail:view" type="primary" icon="el-icon-search" @click="findPage(null)"/>
          <kt-button :label="$t('action.add')" perms="sys:rfMainProcessDetail:add" type="primary" icon="el-icon-plus" @click="handleAdd"/>
        </div>
      </div>
      <!--表格内容栏-->
      <el-table :data="pageResult.content" :highlight-current-row="highlightCurrentRow" @selection-change="selectionChange"
                @current-change="handleCurrentChange" v-loading="loading" :element-loading-text="$t('action.loading')" :border="border" :stripe="stripe"
                :show-overflow-tooltip="showOverflowTooltip" :max-height="maxHeight" :height="height" :size="size" :align="align" style="width:100%;">
        <el-table-column v-for="column in columns" :key="column.prop" :prop="column.prop" :label="$t(column.label)" :width="column.width" :min-width="column.minWidth">
          <template slot-scope="scope">
            <el-link v-if="['dialogOptionName'].includes(column.prop)"
                      type="primary" :underline="false" @click="handleCellClick(scope.row, column.prop)">
              {{ scope.row[column.prop] }}
            </el-link>
            <span v-else>{{ scope.row[column.prop] }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('action.operation')" :width="widthOfOperation" header-align="center" fixed="right" align="left">
          <template slot-scope="scope">
            <div style="padding-top:2px;">
              <kt-button icon="fa fa-edit" :label="$t('action.edit')" perms="sys:rfMainProcessDetail:edit" size="mini" @click="handleEdit(scope.row)" />
            </div>
            <div style="padding-top:2px;">
              <kt-button icon="fa fa-trash" :label="$t('action.delete')" perms="sys:rfMainProcessDetail:delete" size="mini" type="danger" @click="handleDelete(scope.row)" />
            </div>
            <div style="padding-top:2px;">
              <kt-button icon="fa fa-copy" :label="$t('action.copy')" perms="sys:rfMainProcessDetail:add" size="mini" @click="handleCopy(scope.row)" />
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!--新增编辑界面-->
      <el-dialog :title="operation ? $t('common.add') : $t('common.edit')" width="40%" :visible.sync="editDialogVisible" :close-on-click-modal="false">
        <el-form :model="dataForm" label-width="110px" :rules="dataFormRules" ref="dataForm" :size="size">
          <EditWhseClient ref="editWhseClient" @edit-whse-event="getEditWhseClient(arguments)" :whId="dataForm.whId" :clientCode="dataForm.clientCode" perms="sys:rfMainProcessDetail:view" type="primary" :disabled="!operation"/>
          <el-form-item :label="$t('RfSubProcessOption.subProcessName')" prop="subProcessName">
            <el-select v-model="dataForm.subProcessName" :placeholder="$t('RfSubProcessOption.subProcessName')" :disabled="!operation" style="width: 100%;">
              <el-option v-for="(name, index) in subProcessNames" :key="index" :value="name" :label="name"/>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('RfSubProcessOption.dialogOptionName')" prop="dialogOptionName">
            <el-select v-model="dataForm.dialogOptionName" :placeholder="$t('RfSubProcessOption.dialogOptionName')" :disabled="!operation" @focus="fetchProcessResources('option')" style="width: 100%;">
              <el-option v-for="(item, index) in optionOptions" :key="index" :value="item" :label="item"/>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('RfSubProcessOption.dialogOptionDescription')" prop="dialogOptionDescription">
            <el-input v-model="dataForm.dialogOptionDescription" auto-complete="off" :disabled="!operation"></el-input>
          </el-form-item>
          <el-form-item :label="$t('RfSubProcessOption.functionKey')" prop="functionKey">
            <el-select v-model="dataForm.functionKey" :placeholder="$t('RfSubProcessOption.functionKey')" :disabled="!operation" style="width: 100%;">
              <el-option value="BACK" label="BACK"></el-option>
              <el-option value="DONE" label="DONE"></el-option>
              <el-option value="F1" label="F1"></el-option>
              <el-option value="F2" label="F2"></el-option>
              <el-option value="F3" label="F3"></el-option>
              <el-option value="F4" label="F4"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('RfSubProcessOption.nextSubProcessName')" prop="nextSubProcessName">
            <el-select v-model="dataForm.nextSubProcessName" :placeholder="$t('RfSubProcessOption.nextSubProcessName')" :disabled="!operation" style="width: 100%;">
              <el-option value="Exit" label="Exit"></el-option>
              <el-option v-for="(name, index) in subProcessNames" :key="index" :value="name" :label="name"/>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('RfSubProcessOption.execSpBeforeNext')" prop="execSpBeforeNext">
            <el-input v-model="dataForm.execSpBeforeNext" auto-complete="off" :disabled="!operation"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button :size="size" @click.native="editDialogVisible = false">{{$t('action.cancel')}}</el-button>
          <el-button :size="size" type="primary" @click.native="submitForm" :loading="editLoading">{{$t('action.submit')}}</el-button>
        </div>
      </el-dialog>
    </div>
  </template>
  <script>
  import KtButton from "@/views/Core/KtButton"
  import SearchWhseClient from "@/views/Core/SearchWhseClient"
  import EditWhseClient from "@/views/Core/EditWhseClient"
  export default {
    name: 'RfSubProcessOption',
    components: {
      KtButton,
      SearchWhseClient,
      EditWhseClient
    },
    data() {
      return {
        size: 'small',
        filters: {
          whId: '',
          clientCode: '',
          subProcessName: '',
          dialogOptionName: ''
        },
        subProcessNames: [],
        optionOptions: [],
        columns: [
          { prop: "id", label: "RfSubProcessOption.id", minWidth: 100 },
          { prop: "subProcessName", label: "RfSubProcessOption.subProcessName", minWidth: 150 },
          { prop: "dialogOptionName", label: "RfSubProcessOption.dialogOptionName", minWidth: 150 },
          { prop: "dialogOptionDescription", label: "RfSubProcessOption.dialogOptionDescription", minWidth: 200 },
          { prop: "functionKey", label: "RfSubProcessOption.functionKey", minWidth: 100 },
          { prop: "nextSubProcessName", label: "RfSubProcessOption.nextSubProcessName", minWidth: 150 },
          { prop: "whId", label: "RfSubProcessOption.whId", minWidth: 100 },
          { prop: "clientCode", label: "RfSubProcessOption.clientCode", minWidth: 100 },
          { prop: "execSpBeforeNext", label: "RfSubProcessOption.execSpBeforeNext", minWidth: 150 },
          { prop: "createTime", label: "RfSubProcessOption.createTime", minWidth: 150 },
          { prop: "updateTime", label: "RfSubProcessOption.updateTime", minWidth: 150 }
        ],
        pageRequest: { pageNum: 1, pageSize: 200 },
        pageResult: {},
        operation: false,
        editDialogVisible: false,
        editLoading: false,
        dataFormRules: {
            whId: [
            { required: true, message: this.$t('RfSubProcessOption.dataFormRules.whId'), trigger: 'blur' }
            ],
            clientCode: [
            { required: true, message: this.$t('RfSubProcessOption.dataFormRules.clientCode'), trigger: 'blur' }
            ],
            subProcessName: [
            { required: true, message: this.$t('RfSubProcessOption.dataFormRules.subProcessName'), trigger: 'blur' }
            ],
            dialogOptionName: [
            { required: true, message: this.$t('RfSubProcessOption.dataFormRules.dialogOptionName'), trigger: 'blur' }
            ],
            dialogOptionDescription: [
            { required: true, message: this.$t('RfSubProcessOption.dataFormRules.dialogOptionDescription'), trigger: 'blur' }
            ],
            functionKey: [
            { required: true, message: this.$t('RfSubProcessOption.dataFormRules.functionKey'), trigger: 'blur' }
            ],
            nextSubProcessName: [
            { required: true, message: this.$t('RfSubProcessOption.dataFormRules.nextSubProcessName'), trigger: 'blur' }
            ]
        },
        dataForm: {
          id: null,
          subProcessName: null,
          dialogOptionName: null,
          dialogOptionDescription: null,
          functionKey: null,
          nextSubProcessName: null,
          whId: null,
          clientCode: null,
          execSpBeforeNext: null,
          createTime: null,
          updateTime: null
        },
        maxHeight: 520,
        height: 520
      }
    },
    methods: {
      getSearchWhseClient: function (data) {
        this.filters.whId = data[0]
        this.filters.clientCode = data[1]
        this.getSubProcessNames(data[0], data[1])
      },
      getEditWhseClient: function (data) {
        this.dataForm.whId = data[0]
        this.dataForm.clientCode = data[1]
        this.getSubProcessNames(data[0], data[1])
      },
      getSubProcessNames: function (whId, clientCode) {
        this.$wmsApi.rfSubProcessDetail.getSubProcessNames({ whId, clientCode }).then((res) => {
          this.subProcessNames = res.data
        })
      },
      fetchProcessResources(type) {
        this.$wmsApi.rfProcessResource.getProcessResources({ type }).then(res => {
          if (res.code === 200) {
            this.optionOptions = res.data; // 假设返回的数据是一个数组
          }
else {
            this.$message({ message: res.msg, type: 'error' });
          }
        }).catch(error => {
          console.error("Error fetching process resources:", error);
        });
      },
      findPage(data) {
        if (data !== null && data.pageRequest) {
          this.pageRequest.pageNum = data.pageRequest.pageNum
          this.pageRequest.pageSize = data.pageRequest.pageSize;
    }
        let whId = this.filters.whId
        let clientCode = this.filters.clientCode
        let subProcessName = this.filters.subProcessName
        let dialogOptionName = this.filters.dialogOptionName || '%';
        this.pageRequest.columnFilters = {
          whId: { name: 'whId', value: whId },
          clientCode: { name: 'clientCode', value: clientCode },
          subProcessName: { name: 'subProcessName', value: subProcessName },
          dialogOptionName: { name: 'dialogOptionName', value: dialogOptionName }
        }
this.$wmsApi.rfSubProcessOption.findPage(this.pageRequest).then((res) => {
          this.pageResult = res.data;
        }).catch(error => {
          console.error("Error fetching data:", error);
        });
      },
      handleCellClick: function (row, prop) {
        this.$router.push({
        path: "/Wms/RfProcessResourceDetail",
        query: {
            name: row[prop],
            type: '%',
            date: new Date().getTime()
        }
        });
      },
      handleDelete(row) {
        this.$confirm(this.$t("common.message.confirmDelete"), this.$t("common.message.prompt"), {
          confirmButtonText: this.$t("common.message.confirm"),
          cancelButtonText: this.$t("common.message.cancel"),
          type: 'warning'
        }).then(() => {
          this.$wmsApi.rfSubProcessOption.batchDelete(row).then(res => {
            if (res.code === 200) {
              this.$message({ message: this.$t("common.message.success"), type: 'success' });
              this.findPage(null);
            }
else {
              this.$message({ message: this.$t("common.message.fail") + res.msg, type: 'error' });
            }
          });
        });
      },
      handleAdd() {
        this.editDialogVisible = true;
        this.operation = true;
        this.dataForm = {
          id: null,
          whId: this.filters.whId,
          clientCode: this.filters.clientCode,
          subProcessName: null,
          dialogOptionName: null,
          dialogOptionDescription: null,
          functionKey: null,
          nextSubProcessName: null,
          execSpBeforeNext: null,
          createTime: null,
          updateTime: null
        };
      },
      handleCopy(row) {
        this.editDialogVisible = true;
        this.operation = true;
        this.dataForm = {
          id: null,
          whId: row.whId,
          clientCode: row.clientCode,
          subProcessName: row.subProcessName,
          dialogOptionName: row.dialogOptionName,
          dialogOptionDescription: row.dialogOptionDescription,
          functionKey: row.functionKey,
          nextSubProcessName: row.nextSubProcessName,
          execSpBeforeNext: row.execSpBeforeNext,
          createTime: null,
          updateTime: null
        };
        this.getSubProcessNames(row.whId, row.clientCode);
      },
      handleEdit(row) {
        this.editDialogVisible = true;
        this.operation = true;
        this.dataForm = Object.assign({}, row);
        this.getSubProcessNames(row.whId, row.clientCode);
      },
      submitForm() {
        this.$refs.dataForm.validate((valid) => {
          if (valid) {
            // 校验 whId 和 clientCode
            if (!this.dataForm.whId || !this.dataForm.clientCode) {
              this.$message({ message: this.$t("common.message.requiredFields"), type: 'warning' });
              return;
            }
this.editLoading = true;
            this.$wmsApi.rfSubProcessOption.save(this.dataForm).then(res => {
              if (res.code === 200) {
                this.$message({ message: this.$t("common.message.success"), type: 'success' });
                this.editDialogVisible = false;
                this.findPage(null);
              }
else {
                this.$message({ message: this.$t("common.message.fail") + res.msg, type: 'error' });
              }
this.editLoading = false;
            }).catch(error => {
              this.editLoading = false;
              console.error("Error saving data:", error);
            });
          }
        });
      }
    },
    activated() {
      // 获取路由参数
      const { whId, clientCode, subProcessName } = this.$route.query;
      // 设置 filters
      if (whId!==undefined) {
        this.filters.whId = whId || ''; // 默认值为空字符串
      }
if (clientCode!==undefined) {
        this.filters.clientCode = clientCode || ''; // 默认值为空字符串
      }
if (subProcessName!==undefined) {
        this.filters.subProcessName = subProcessName || ''; // 默认值为空字符串
      }
      // 刷新子流程下拉框数据
      if (this.filters.whId && this.filters.clientCode) {
        this.getSubProcessNames(this.filters.whId, this.filters.clientCode);
      }
      // 增加判断，只有在三个参数都不为空时才调用 findPage
      if (this.filters.whId && this.filters.clientCode && this.filters.subProcessName) {
          this.findPage(null);
      }
    }
  }
  </script>
  <style scoped>
/* 工业软件风格 - 工具栏整体布局 */
.toolbar {
  font-family: "PingFang SC", "Microsoft YaHei", -apple-system, sans-serif;
}
/* 筛选条件区 - 工业软件卡片风格 */
.filter-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  padding: 10px 14px;
  background: linear-gradient(135deg, #f8f9fb 0%, #ffffff 100%);
  border: 1px solid #e4e7ed;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
  margin-bottom: 10px;
}
/* 筛选分组 */
.filter-group {
  display: flex;
  align-items: center;
  gap: 6px;
  padding-right: 10px;
  border-right: 1px solid #dcdfe6;
  margin-right: 6px;
}
/* 筛选分隔线 */
.filter-divider {
  width: 1px;
  height: 24px;
  background: linear-gradient(180deg, transparent 0%, #dcdfe6 50%, transparent 100%);
  margin: 0 4px;
}
/* 单个筛选项 */
.filter-item {
  display: flex;
  align-items: center;
  gap: 5px;
}
/* 筛选标签 */
.filter-label {
  font-size: 12px;
  color: #606266;
  font-weight: 500;
  white-space: nowrap;
  min-width: 52px;
  text-align: right;
}
/* 操作按钮区 */
.action-bar {
  display: flex;
  align-items: center;
  gap: 10px;
  padding-left: 6px;
}
/* 响应式 - 小屏幕 */
@media screen and (max-width: 1200px) {
  .filter-bar {
    padding: 8px 10px;
  }
  .filter-label {
    display: none;
  }
  .filter-group {
    border-right: none;
    padding-right: 6px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/Wms/RfSubProcessOption.vue